/* Split-reveal: paragraphs reveal line-by-line as they enter the viewport,
   each line rising out of a mask. Progressive enhancement -- if this never
   runs, the text renders as ordinary paragraphs. */
(function () {
  'use strict';

  var SEL = [
    '[data-ts-split]',
    // Forschung page: scoped via the section custom_class 'ts-research'
    '.ts-research .rich-text__text p',
    '.ts-research .rich-text__heading'
  ].join(',');
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  function splitLines(el) {
    if (el.dataset.tsSplitDone === '1') return;
    var text = el.textContent.replace(/\s+/g, ' ').trim();
    if (!text) return;

    el.setAttribute('aria-label', text);

    // Wrap each word so the browser can still line-break naturally; the
    // mask sits on the word, so wrapping never clips mid-line.
    var words = text.split(' ');
    el.innerHTML = words.map(function (w, i) {
      return '<span class="ts-sr__w" aria-hidden="true">' +
             '<span class="ts-sr__i" style="--ts-sr-d:' + (i * 26) + 'ms">' +
             w.replace(/&/g, '&amp;').replace(/</g, '&lt;') +
             '</span></span>';
    }).join(' ');

    el.dataset.tsSplitDone = '1';
  }

  function init() {
    var nodes = Array.prototype.slice.call(document.querySelectorAll(SEL));
    if (!nodes.length) return;

    if (reduced.matches) {
      nodes.forEach(function (n) { n.classList.add('ts-sr-in'); });
      return;
    }

    nodes.forEach(function (n) {
      splitLines(n);
      n.classList.add('ts-sr');
    });

    if (!('IntersectionObserver' in window)) {
      nodes.forEach(function (n) { n.classList.add('ts-sr-in'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('ts-sr-in');
        } else if (e.boundingClientRect.top > 0) {
          e.target.classList.remove('ts-sr-in');
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -50px 0px' });

    nodes.forEach(function (n) { io.observe(n); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
  document.addEventListener('shopify:section:load', init);
})();
